import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';
import type { BaseContext } from '@/types';
import { ROSA_QUERY_KEYS } from './query-keys';

type Element = {
	name: string;
	action: string;
	priority: number;
};

export type OtherElement = Element & {
	id: string;
};

type GetRequiredEquipmentsRequest = BaseContext & {
	report_id: string;
};

type GetRequiredEquipmentsResponse = {
	required: Element[];
	table: OtherElement[];
};

async function getRequiredEquipments(params: GetRequiredEquipmentsRequest): Promise<GetRequiredEquipmentsResponse> {
	const { report_id } = params;

	const url = `ergonomic-tool/rosa/required-equipments/${report_id}`;
	const { data } = await Api.get(url, { params });

	return data;
}

export const useGetRequiredEquipments = (params: GetRequiredEquipmentsRequest) => {
	const data = useQuery([ROSA_QUERY_KEYS.GET_REQUIRED_EQUIPMENTS], () => getRequiredEquipments(params), {
		retry: 0
	});
	return data;
};
